import { IDirective, IDirectiveFactory, IScope } from "angular";

import { IConfidenceMapping } from "@gtmhub/core";
import { IGtmhubRootScopeService } from "@gtmhub/models";
import { getConfidenceFloatNumber, getFloattedMappings, findRange } from "./confidence-preview";
import { ConfidenceScale, ConfidenceType } from "@gtmhub/configuration/controllers/confidence-settings";
import { AccountService } from "@gtmhub/accounts/accounts-service";
import noUiSlider from "nouislider";

export interface ISetConfidenceScope extends IScope {
  confidence: unknown;
  confidenceType: ConfidenceType;
  confidenceValue: number;
  confidenceScale: ConfidenceScale;
  mappings: IConfidenceMapping[];
  currentMapping: IConfidenceMapping;
  setCurrentMapping(mapping: IConfidenceMapping): void;
}

export class SetConfidence implements IDirective {
  public scope = {
    confidenceValue: "@",
    confidence: "=",
  };
  public restrict = "E";
  public templateUrl = require("../views/set-confidence.jade");

  constructor(private $rootScope: IGtmhubRootScopeService, private accountService: AccountService) {}

  public link(scope: ISetConfidenceScope): void {
    const scaleFactor = 10;

    const init = () => {
      scope.confidenceValue = getConfidenceFloatNumber(scope.confidenceValue, scaleFactor);
      scope.confidenceType = this.$rootScope.confidenceSettings.confidenceType ? this.$rootScope.confidenceSettings.confidenceType : "numeric";
      scope.mappings = getFloattedMappings(
        angular.copy(this.$rootScope.confidenceSettings.confidenceMapping).sort((a: IConfidenceMapping, b: IConfidenceMapping) => a.range.to - b.range.to),
        scaleFactor
      );
      scope.confidenceScale = this.accountService.getConfidenceScale();

      const mapping = findRange(scope.confidenceValue, scope.mappings);
      scope.currentMapping = mapping;
    };
    init();

    scope.$watch("confidenceValue", (newValue: number) => {
      if ((newValue || newValue === 0) && scope.confidenceType === "numeric") {
        scope.confidence = newValue;
        init();
      }
    });

    scope.setCurrentMapping = (mapping: IConfidenceMapping): void => {
      scope.currentMapping = mapping;
      scope.confidence = mapping.range.to;
    };

    /** slider is active only for numeric confidence */
    if (scope.confidenceType === "numeric") {
      const slider = noUiSlider.create(document.getElementById("slider"), {
        start: [scope.confidenceValue],
        step: 0.1,
        range: {
          min: 0,
          max: 1,
        },
      });

      slider.on("change", (valueArr) => {
        const value = +valueArr[0];
        scope.currentMapping = findRange(value, scope.mappings);
        scope.confidenceValue = value; /** used to display value respecitvely the confidence scale */
        scope.confidence = value; /** mutating metric.confidence directly by reference before the update */
        scope.$digest(); /** slider is non framework library, ensure to update the view whenever an update performs */
      });

      scope.$on("$destroy", slider.destroy);
    }
  }

  public static factory(): IDirectiveFactory {
    const directive = ($rootScope: IGtmhubRootScopeService, accountService: AccountService) => new SetConfidence($rootScope, accountService);
    directive.$inject = ["$rootScope", "AccountService"];

    return directive;
  }
}
